import React, { useState } from "react";
import * as Style from "./styles/loader";
import loader from "../../../assets/SVGs/bars.svg";

function NewLoader({ isLoading }) {
  return isLoading ? (
    <div >
      <Style.LoaderNew>
        <Style.LoaderContentNew onClick={(e) => e.stopPropagation()}>
          {/* <div>Loading</div> */}
          <img src={loader} height={50} width={50} alt="asset planet loader" />
        </Style.LoaderContentNew>
      </Style.LoaderNew>
    </div>
  ) : null;
}

export default NewLoader;
